import { Flex, ProgressCircle } from '@chakra-ui/react';

const Loading = () => (
  <Flex justifyContent="center" alignItems="center" p={4} colorPalette="argos">
    <ProgressCircle.Root value={null} size="sm">
      <ProgressCircle.Circle>
        <ProgressCircle.Track />
        <ProgressCircle.Range />
      </ProgressCircle.Circle>
    </ProgressCircle.Root>
  </Flex>
);

export default Loading;
